import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, FileCheck, User, Shield } from 'lucide-react';

const DocumentValidation = ({ uploadedFiles = [] }) => {
  const detectedSignatures = [
    {
      role: 'Representante Legal',
      name: 'Gerardo Andrés Hernández Montes',
  
      status: 'verified',
      icon: User,
      color: '#10b981'
    },
    {
      role: 'Contador',
      name: 'Mario Alberto Casallas Ramírez', 
      tarjeta: '164763-T',
      status: 'verified',
      icon: FileCheck,
      color: '#3b82f6'
    },
    {
      role: 'Revisor Fiscal',
      name: 'Nubia Hernández Torres',
      status: 'verified', 
      tarjeta: '87113-T',
      icon: Shield,
      color: '#8b5cf6'
    }
  ];

  return (
    <div style={{ padding: '24px', width: '100%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', paddingBottom: '24px', borderBottom: '1px solid #e5e7eb' }}>
        <div style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white', padding: '12px', borderRadius: '12px' }}>
          <FileCheck size={24} />
        </div>
        <div>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
            Validación de Firmas Requeridas
          </h2>
          <p style={{ margin: 0, color: '#6b7280', fontSize: '16px' }}>
            Verificación de firmas y cumplimiento normativo
          </p>
        </div>
      </div>

      {/* Signatures Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '20px' }}>
        {detectedSignatures.map((signature, index) => {
          const Icon = signature.icon;
          
          return (
            <motion.div
              key={signature.role}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              style={{
                background: 'white',
                border: `2px solid ${signature.color}`,
                borderRadius: '16px',
                padding: '24px',
                boxShadow: `0 4px 20px ${signature.color}20`,
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              {/* Background Pattern */}
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '100px',
                height: '100px',
                background: `linear-gradient(135deg, ${signature.color}10, ${signature.color}05)`,
                borderRadius: '50%',
                transform: 'translate(30px, -30px)'
              }} />

              {/* Content */}
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                  <div style={{
                    background: signature.color,
                    color: 'white',
                    padding: '10px',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon size={20} />
                  </div>
                  <div>
                    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                      {signature.role}
                    </h3>
                  </div>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '500', color: '#374151' }}>
                    {signature.name}
                  </p>
                  <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '500', color: '#374151' }}>
                    {signature.tarjeta ? `Tarjeta: ${signature.tarjeta}` : ''}
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <CheckCircle size={16} style={{ color: '#10b981' }} />
                    <span style={{ fontSize: '14px', color: '#10b981', fontWeight: '600' }}>
                      Firma verificada
                    </span>
                  </div>
                </div>

                {/* Status Badge */}
                <div style={{
                  background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                  border: '1px solid #10b981',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <div style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: '#10b981'
                  }} />
                  <span style={{ fontSize: '12px', color: '#065f46', fontWeight: '600' }}>
                    VÁLIDA
                  </span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* Validation Result */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.8 }}
        style={{
          background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
          border: '2px solid #10b981',
          borderRadius: '16px',
          padding: '32px',
          textAlign: 'center',
          marginTop: '24px',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Background decoration */}
        <div style={{
          position: 'absolute',
          top: '-50%',
          left: '-50%',
          width: '200%',
          height: '200%',
          background: 'radial-gradient(circle, rgba(16, 185, 129, 0.05) 0%, transparent 70%)',
          transform: 'rotate(45deg)'
        }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 1, type: "spring", stiffness: 200 }}
            style={{ marginBottom: '16px' }}
          >
            <CheckCircle size={64} style={{ color: '#10b981' }} />
          </motion.div>

          <h3 style={{ 
            margin: '0 0 12px 0', 
            fontSize: '28px', 
            fontWeight: '700', 
            color: '#065f46' 
          }}>
            Validación Superada
          </h3>

          <p style={{ 
            margin: '0 0 20px 0', 
            fontSize: '16px', 
            color: '#047857',
            maxWidth: '600px',
            marginLeft: 'auto',
            marginRight: 'auto',
            lineHeight: '1.6'
          }}>
            Se cumple requisito de firmas. El documento cuenta con firmas de las siguientes personas:  <br />
            <b>Representante Legal:</b> Gerardo Andrés Hernández Montes <br />
            <b>Contador:</b> Mario Alberto Casallas Ramírez <br />
            <b>Revisor Fiscal:</b> Nubia Hernández Torres <br />
          </p>

          {/* Summary Stats */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: '32px',
            marginTop: '24px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '24px', 
                fontWeight: '700', 
                color: '#10b981',
                marginBottom: '4px'
              }}>
                3/3
              </div>
              <div style={{ fontSize: '14px', color: '#047857' }}>
                Firmas Verificadas
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                fontSize: '24px', 
                fontWeight: '700', 
                color: '#10b981',
                marginBottom: '4px'
              }}>
                100%
              </div>
              <div style={{ fontSize: '14px', color: '#047857' }}>
                Cumplimiento
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default DocumentValidation; 